import dataService from './dataService';
import config from 'root/../config';
import MsgBox from 'sis_ui/modules/notifications';
import languageService from './languageService';
import { i18nInit } from '../internationalization/config';

const userService = {
    areUserDetailsLoadedAndRoleSet: (context) => {
        return Object.keys(context.userDetails).length && userService.getUserRole()
    },
    populateUserDetails: (context, callback = ()=>{}) => {
        if (!userService.areUserDetailsLoadedAndRoleSet(context)) {
            let userDetailsRequest = dataService.request({method: 'GET', url: config.apiAppUrl + config.APIs.getUserDetails})
            .accept('application/json');
            
            userDetailsRequest.then((res) => {
                try {
                    const result = res.body;

                    if(userService.getUserRole()) {
                        result.CURRENT_ROLE = userService.getUserRole();
                    }
                    
                    if(result.LANGUAGE_CODE !== languageService.getUserLanguage() && typeof result.LANGUAGE_CODE !== 'undefined' && result.LANGUAGE_CODE.trim() !== ""){
                        const newLanguage = languageService.getLanguageSettingsByCode(result.LANGUAGE_CODE)
                        if(typeof newLanguage !== 'undefined'){
                            languageService.changeLanguage(newLanguage);
                        }
                    }

                    context.setUserDetails(result);
                    callback();
                } catch (e) {
                    MsgBox.drawMessage('error',i18nInit.t('lbl.INVALID_RESPONSE','Invalid response format'));
                }
            }, e => {
            });

            return userDetailsRequest;
        }
    },
    setUserRole: (currentRole) => { 
        if (currentRole) {
            window.localStorage.setItem('CURRENT_ROLE', currentRole);
        } else {
            window.localStorage.removeItem('CURRENT_ROLE');
        }
    },
    getUserRole: () => {return window.localStorage.getItem('CURRENT_ROLE')},
}

export default userService;